import { useEffect, useState, ReactNode, useRef } from "react";
import Modal from "../../../common/modals";
import {
  Add,
  ChevronBottom,
  Cross,
  FolderPlus,
  ImagesIcon,
  FileText,
  File,
  PlayCircle,
} from "../../../../icons";
import Button from "../../../common/button";
import { closeModal } from "../../../../store/slices/modalSlice";
import {
  Cards,
  HandCoins,
  ShieldPlus,
  ShieldCheck,
  CurrencyBtc,
  Money,
  BuildingApartent,
  CoinVertical,
  ChartBar,
  StockMarketIcon,
  OtherExpensesIcon,
  OtherInvestmentsIcon,
  VehicleIcon,
  TaxIcon,
  NewFeatureIcon,
  MemesIcon,
  ContestIcon,
  CommunityUpdatesIcon,
  OPCExperienceIcon,
} from "../../../../icons/tags-icons";
import {
  useCreatePostMutation,
  useEditPostMutation,
} from "../../../../store/api/homeApi";
import { useAppDispatch, useAppSelector } from "../../../../hooks/store-hooks";
import { addPostData } from "../../../../store/slices/homeSlice";
import PdfViewer from "../../../common/pdf-viewer";
import { toastError } from "../../../toast";
import { MIME_TYPE_MAPPING } from "../../../../constants";
import { isPDF, formatFileSize } from "../../../../helpers";
import { BtnLoader } from "../../../../icons";
import { CrossIcon } from "../../../../icons";
import ProfileImageComp from "../../../common/profile";
import { getLocalStorage } from "../../../../helpers/storage";
export interface TagWithIcon {
  name: string;
  icon: ReactNode;
  color: string;
  isAdminTag: boolean;
  backgroundColor: string;
  isFilterable?: boolean;
}

export const tags: TagWithIcon[] = [
  {
    name: "Credit Cards",
    icon: <Cards />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Crypto",
    icon: <CurrencyBtc />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Debt Mutual Fund",
    icon: <HandCoins />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Equity Mutual Fund",
    icon: <CoinVertical />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Fixed Deposit",
    icon: <Money />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Health Insurance",
    icon: <ShieldPlus />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Life Insurance",
    icon: <ShieldCheck />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Loans",
    icon: <HandCoins />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Real Estate",
    icon: <BuildingApartent />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Stock Market",
    icon: <StockMarketIcon />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Tax",
    icon: <TaxIcon />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Vehicle Insurance",
    icon: <VehicleIcon />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Other Expenses",
    icon: <OtherExpensesIcon />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Other Investments",
    icon: <OtherInvestmentsIcon />,
    color: "#1640C1",
    isAdminTag: false,
    backgroundColor: "#E7ECFC",
    isFilterable: true,
  },
  {
    name: "Memes",
    icon: <MemesIcon />,
    color: "#CCA300",
    isAdminTag: false,
    backgroundColor: "#FFF7D6",
    isFilterable: true,
  },
  {
    name: "Contest",
    icon: <ContestIcon />,
    color: "#EE4D37",
    isAdminTag: true,
    backgroundColor: "#FCDDD9",
    isFilterable: false,
  },
  {
    name: "New Feature",
    icon: <NewFeatureIcon />,
    color: "#227D12",
    isAdminTag: true,
    backgroundColor: "#DBF9D5",
    isFilterable: false,
  },
  {
    name: "Community Updates",
    icon: <CommunityUpdatesIcon />,
    color: "#0B59AD",
    isAdminTag: true,
    backgroundColor: "#C5E0FB",
    isFilterable: false,
  },
  {
    name: "1% Club Experiences",
    icon: <OPCExperienceIcon />,
    color: "#F17726",
    isAdminTag: true,
    backgroundColor: "#FDE7D9",
    isFilterable: false,
  },
];

export interface PollOption {
  option: string;
  votes: number;
}

export interface PostAttachments {
  images: string[];
  video: string;
  audio: string;
  file: string;
}

export interface PostData {
  id: string;
  postMessage: string;
  created_at: Date;
  likes: number;
  liked: boolean;
  pined: boolean;
  attachments: PostAttachments;
  comments: [];
  tags: [];
  poll: {
    options: PollOption[];
  } | null;
  already_voted: boolean;
  selected_options: [];
}

interface FileAttachments {
  images: File[];
  video: File | null;
  audio: File | null;
  file: File | null;
}

interface PreviewUrls {
  images: string[];
  video: string;
  audio: string;
  file: string;
}

interface CreateFeedProps {
  activityId?: string | undefined;
  refetchUserPostData?: any;
}

const CreateFeed: React.FC<CreateFeedProps> = ({
  activityId,
  refetchUserPostData,
}) => {
  const defaultPostData: Partial<PostData> = useAppSelector(
    (state) => state.modal?.modalData || {},
  );
  const [globalModalOpen, setGlobalModalOpen] = useState(true);
  const [isShowFileUploadPopup, setIsShowFileUploadPopup] = useState(false);
  const [showIcons, setShowIcons] = useState(false);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [message, setMessage] = useState("");
  const [isPollActive, setIsPollActive] = useState(false);
  const [pollOptions, setPollOptions] = useState<string[]>(["Yes", "No"]);
  const [pollDuration, setPollDuration] = useState("1");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [allowedMultiple, setAllowedMultiple] = useState(false);
  const { modalData } = useAppSelector((state: any) => state.modal ?? {});
  const user = JSON.parse(getLocalStorage("userData") || "{}");
  const dispatch = useAppDispatch();
  const [createPost, { isLoading }] = useCreatePostMutation();
  const [editPost] = useEditPostMutation();

  const [attachments, setAttachments] = useState<FileAttachments>({
    images: [],
    video: null,
    audio: null,
    file: null,
  });
  const [previewUrls, setPreviewUrls] = useState<PreviewUrls>({
    images: [],
    video: "",
    audio: "",
    file: "",
  });
  const MAX_FILE_SIZE = 50 * 1024 * 1024;
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedFileType, setSelectedFileType] = useState<string>("image");

  const handleFileValidation = (file: File) => {
    if (file.size > MAX_FILE_SIZE) {
      toastError({ message: "File size must be less than 50MB" });
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (defaultPostData) {
      setMessage(defaultPostData.postMessage || "");
      setSelectedTags(defaultPostData.tags || []);
      if (defaultPostData.attachments) {
        setPreviewUrls({
          images: defaultPostData.attachments.images || [],
          video: defaultPostData.attachments.video || "",
          audio: defaultPostData.attachments.audio || "",
          file: defaultPostData.attachments.file || "",
        });
      }
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsModalOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isModalOpen]);

  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    // Focus the textarea when component mounts
    textareaRef.current?.focus();
  }, []);

  useEffect(() => {
    if (modalData?.isImageFirst) {
      setIsShowFileUploadPopup(true);
    }
  }, [modalData?.isImageFirst]);

  const handleSelectTags = (tag: string) => {
    setSelectedTags((prevTags) =>
      prevTags.includes(tag)
        ? prevTags.filter((t) => t !== tag)
        : [...prevTags, tag],
    );
    setShowIcons(false);
  };

  const handleRemoveTag = (tagName: string) => {
    setSelectedTags((prevSelectedTags) =>
      prevSelectedTags.filter((tag) => tag !== tagName),
    );
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    if (!handleFileValidation(files[0])) {
      return;
    }

    setIsUploading(true);

    const newAttachments: FileAttachments = {
      images: [],
      video: null,
      audio: null,
      file: null,
    };

    const newPreviewUrls: PreviewUrls = {
      images: [],
      video: "",
      audio: "",
      file: "",
    };

    Array.from(files).forEach((file) => {
      const fileType = file.type.split("/")[0];
      switch (fileType) {
        case "image": {
          newAttachments.images.push(file);
          const imageUrl = URL.createObjectURL(file);
          newPreviewUrls.images.push(imageUrl);
          break;
        }
        case "video": {
          if (!newAttachments.video) {
            newAttachments.video = file;
            newPreviewUrls.video = URL.createObjectURL(file);
          }
          break;
        }
        case "audio": {
          if (!newAttachments.audio) {
            newAttachments.audio = file;
            newPreviewUrls.audio = URL.createObjectURL(file);
          }
          break;
        }
        case "application": {
          newAttachments.file = file;
          if (file.type === "application/pdf") {
            const pdfUrl = URL.createObjectURL(
              new Blob([file], { type: "application/pdf" }),
            );
            newPreviewUrls.file = pdfUrl;
          }
          break;
        }
        default:
          break;
      }
    });

    setAttachments(newAttachments);
    setPreviewUrls(newPreviewUrls);
    setIsShowFileUploadPopup(false);

    await new Promise((resolve) => setTimeout(resolve, 2000));
    setIsUploading(false);
  };

  const handleAddPollOption = () => {
    setPollOptions([...pollOptions, ""]);
  };

  const handlePollOptionChange = (index: number, value: string) => {
    const newOptions = [...pollOptions];
    newOptions[index] = value;
    setPollOptions(newOptions);
  };

  const createPostHandler = async () => {
    const formData = new FormData();
    formData.append("tags", JSON.stringify(selectedTags));
    formData.append("message", message);

    let removeAttachment = true;

    attachments.images.forEach((image) => {
      formData.append("images", image);
      removeAttachment = false;
    });

    if (attachments.video) {
      formData.append("video", attachments.video);
      removeAttachment = false;
    }

    if (attachments.audio) {
      formData.append("audio", attachments.audio);
      removeAttachment = false;
    }

    if (attachments.file) {
      formData.append("file", attachments.file);
      removeAttachment = false;
    }

    formData.append("remove_attachment", removeAttachment.toString());

    if (isPollActive || (defaultPostData?.poll?.options?.length ?? 0) > 0) {
      const now = new Date();
      const expiresAt = new Date(
        now.getTime() + +pollDuration * 24 * 60 * 60 * 1000,
      );

      const formattedPoll = isPollActive
        ? pollOptions.map((option) => ({ option, votes: 0 }))
        : defaultPostData?.poll?.options || [];

      formData.append("poll", JSON.stringify(formattedPoll));
      formData.append("expires_at", expiresAt.toISOString());
      formData.append("allow_multiple", allowedMultiple.toString());
    }

    try {
      let response;
      // If editing an existing post, check for default data
      if (defaultPostData.postMessage || defaultPostData.attachments) {
        response = await editPost({
          id: defaultPostData.id,
          updatedPost: formData,
        }).unwrap();
      } else {
        // Create a new post if no default data
        response = await createPost(formData).unwrap();
      }

      if (response?.success) {
        const now = new Date();
        if (activityId) {
          refetchUserPostData();
        }
        dispatch(closeModal());
        if (!defaultPostData.postMessage && !defaultPostData.attachments) {
          dispatch(
            addPostData({
              posts: [
                {
                  id: response.data?.post?._id,
                  user: { ...user, self: true },
                  tags: selectedTags,
                  postMessage: message,
                  attachments: response?.data?.post?.attachments,
                  created_at: new Date(),
                  likes: 0,
                  liked: false,
                  already_voted: false,
                  ...(isPollActive
                    ? {
                        poll: {
                          options: pollOptions.map((option) => ({
                            option,
                            votes: 0,
                          })),
                          allow_multiple: allowedMultiple,
                          expires_at: new Date(
                            now.getTime() + +pollDuration * 24 * 60 * 60 * 1000,
                          ), // Ensure pollDuration is a valid number
                        },
                      }
                    : { poll: {} }),
                },
              ],
              isReset: false,
              onTop: true,
            }),
          );
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleClose = () => {
    setGlobalModalOpen(false);
    setTimeout(() => {
      dispatch(closeModal());
    }, 233);
  };

  const handleRemovePollOption = (index: number) => {
    const newOptions = pollOptions.filter((_, i) => i !== index);
    setPollOptions(newOptions);
  };

  const handlePostType = () => {
    setIsPollActive(true);
    setIsModalOpen(false);
  };

  const removeAttachment = (type: "images" | "video" | "audio" | "file") => {
    setAttachments((prev) => ({
      ...prev,
      [type]: type === "images" ? [] : null,
    }));
    setPreviewUrls((prev) => ({
      ...prev,
      [type]: type === "images" ? [] : "",
    }));
  };

  const renderAttachments = () => {
    return (
      <div className="mt-4 w-full flex justify-center">
        <>
          {previewUrls.images.length > 0 && (
            <div className="relative w-4/5">
              <>
                <img src={previewUrls?.images[0]} />
                <span
                  className="cursor-pointer absolute top-2 right-2"
                  onClick={() => removeAttachment("images")}
                >
                  <CrossIcon />
                </span>
              </>
            </div>
          )}
          {previewUrls.video && (
            <div className="relative">
              <video
                src={previewUrls.video}
                controls
                className="w-full object-contain max-h-72 mt-4"
              />
              <span
                className="cursor-pointer absolute top-2 right-2"
                onClick={() => removeAttachment("video")}
              >
                <CrossIcon />
              </span>
            </div>
          )}
          {previewUrls.audio && (
            <div className="relative bg-gray-100 p-2 rounded w-full">
              <audio
                src={previewUrls.audio}
                controls
                className="w-full max-h-72 mt-4"
              />
              <span
                className="cursor-pointer absolute top-2 right-2"
                onClick={() => removeAttachment("audio")}
              >
                <CrossIcon />
              </span>
            </div>
          )}
          {attachments.file &&
            (isPDF(previewUrls.file) ? (
              <>
                <div className="relative">
                  <PdfViewer
                    pdfUrl={previewUrls.file}
                    width="100%"
                    height="400px"
                  />
                  <span
                    className="cursor-pointer absolute top-2 right-2"
                    onClick={() => removeAttachment("file")}
                  >
                    <CrossIcon />
                  </span>
                </div>
              </>
            ) : (
              <div className="bg-[#E7ECFC] p-4 flex items-center justify-between max-w-2xl rounded-lg shadow">
                <div className="flex items-center gap-3">
                  <FileText />
                  <div>
                    <h2 className="text-lg font-medium">
                      {attachments.file?.name}
                    </h2>
                    <p className="text-sm text-gray-500">
                      {formatFileSize(attachments.file.size)} ·{" "}
                      {
                        MIME_TYPE_MAPPING[
                          attachments.file
                            .type as keyof typeof MIME_TYPE_MAPPING
                        ]
                      }{" "}
                    </p>
                  </div>
                </div>
                <span
                  className="cursor-pointer ml-4"
                  onClick={() => removeAttachment("file")}
                >
                  {isUploading ? <BtnLoader /> : <CrossIcon />}
                </span>
              </div>
            ))}
        </>
      </div>
    );
  };

  const renderTags = () => {
    return (
      <>
        {showIcons && (
          <div className="absolute top-full mt-2 w-44 shadow-dark-card rounded-lg bg-white overflow-y-scroll h-72 z-20">
            {tags.map((tag, index) =>
              tag.isAdminTag ? (
                <></>
              ) : (
                <div
                  key={index}
                  className={`flex items-center p-2 hover:bg-gray-100 cursor-pointer border-b border-b-solid border-b-primary-600 gap-2 ${selectedTags.includes(tag.name) && "bg-[#F2F2F7] font-semibold"}`}
                  onClick={() => handleSelectTags(tag.name)}
                >
                  {tag.icon}
                  <span style={{ color: tag.color }}>{tag.name}</span>
                  {selectedTags.includes(tag.name) && (
                    <span
                      className="ml-auto cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveTag(tag.name);
                      }}
                    >
                      <Cross customClassName="w-4 h-4" />
                    </span>
                  )}
                </div>
              ),
            )}
          </div>
        )}
      </>
    );
  };

  const renderPollContent = () => {
    if (!isPollActive) return null;
    const isEditingPoll = defaultPostData.id !== undefined;

    return (
      <div className="mt-4 w-full">
        <span>Ask a question</span>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Ask a question"
          className="w-full px-2 py-4 border rounded-md"
        ></textarea>
        <div className=" mt-10">
          {pollOptions.map((option, index) => (
            <div key={index} className="flex items-center mb-2">
              <input
                type="text"
                value={option}
                onChange={(e) => handlePollOptionChange(index, e.target.value)}
                placeholder={`Option ${index + 1}`}
                className="w-full p-2 border rounded-md"
                disabled={isEditingPoll}
              />
              {!isEditingPoll && (
                <button
                  onClick={() => handleRemovePollOption(index)}
                  className="ml-2 text-red-500 hover:text-red-700"
                  disabled={isEditingPoll}
                >
                  <Cross />
                </button>
              )}
            </div>
          ))}
        </div>
        {!isEditingPoll && (
          <button
            onClick={handleAddPollOption}
            className="text-blue-500 hover:text-blue-700"
          >
            + Add option
          </button>
        )}
        <select
          value={pollDuration}
          onChange={(e) => setPollDuration(e.target.value)}
          className="w-full p-2 border rounded-md mt-3"
        >
          <option value="1">1 day</option>
          <option value="3">3 days</option>
          <option value="7">7 days</option>
          <option value="14">14 days</option>
        </select>
        <div className="flex items-center mt-4">
          <input
            type="checkbox"
            checked={allowedMultiple}
            onChange={() => setAllowedMultiple((prev) => !prev)}
            className="mr-2 h-5 w-5"
          />
          <label>Allow multiple selections</label>
        </div>
      </div>
    );
  };

  const handleSelectFileType = (type: string) => {
    setSelectedFileType(type);
    setIsShowFileUploadPopup(true);
  };

  const renderMainContent = () => {
    return (
      <div className="flex flex-col items-start p-6 h-fit max-h-[600px]">
        <div className="h-full w-full overflow-scroll flex flex-col">
          <div className="flex items-center w-full justify-between">
            <div
              className="flex items-center p-2 hover:bg-primary-600 rounded-xl-10 relative cursor-pointer"
              onClick={() => setShowIcons(!showIcons)}
            >
              {renderTags()}
              <div className="w-12 h-12 rounded-full mr-1 bg-primary-700 flex items-center">
                {user?.profile_picture ? (
                  <ProfileImageComp
                    imageUrl={user?.profile_picture}
                    customClass="h-12 w-12"
                    is_opc={user?.memberships?.is_opc}
                  />
                ) : null}
              </div>
              <div className="text-black py-2 px-2 rounded-md relative font-semibold flex items-center">
                <div className="mr-2">
                  {selectedTags.length > 0
                    ? selectedTags.join(", ")
                    : "Add Tags"}
                </div>
                <div
                  className={`mt-0.5 cursor-pointer transition delay-150 duration-300 ease-out-in ${
                    showIcons ? "-rotate-180" : ""
                  }`}
                >
                  <ChevronBottom />
                </div>
              </div>
            </div>
            <div
              onClick={() => handleClose()}
              className="text-black cursor-pointer"
            >
              <Cross />
            </div>
          </div>
          <div
            className={`w-full mt-8 flex-grow ${isPollActive ? "hidden" : ""}`}
          >
            <textarea
              ref={textareaRef}
              value={message}
              maxLength={4000}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full min-h-72 h-fit text-gray-700 placeholder-primary-550 focus:outline-none resize-none text-xl"
              placeholder="Write Something..."
            ></textarea>
          </div>
          {renderAttachments()}
          {renderPollContent()}
        </div>
        <div className="w-full mt-4">
          <div className="flex items-center justify-between">
            <div className="flex space-x-4 relative">
              <div
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
                onClick={() => handleSelectFileType("image")}
              >
                <ImagesIcon width={28} height={28} />
              </div>
              <div
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
                onClick={() => handleSelectFileType("video")}
              >
                <PlayCircle width={24} height={24} />
              </div>
              <div
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
                onClick={() => handleSelectFileType("file")}
              >
                <File width={24} height={24} />
              </div>
            </div>
            <button
              className={`text-gray-500 hover:text-gray-700 ${
                isPollActive ? "text-blue-500" : ""
              }`}
              onClick={() => setIsModalOpen(true)}
            >
              {
                <div
                  ref={wrapperRef}
                  className={`absolute bottom-24 mb-2 right-5 bg-white shadow-lg p-4 rounded-md z-50 flex flex-row gap-2 w-[180px] items-center ${isModalOpen ? "" : "hidden"}`}
                  onClick={handlePostType}
                >
                  <ChartBar />
                  Poll
                </div>
              }
              <Add height={18} />
            </button>
          </div>
          <div className="w-full mt-4 border-t pt-4 border-gray-300 flex justify-end ">
            <Button
              customClasses={` bg-secondary-300 ${
                message === "" &&
                attachments.images.length === 0 &&
                !attachments.video &&
                !attachments.audio &&
                "!bg-gray-200"
              } text-white h-auto !py-1.5 px-4 text-lg font-medium !rounded-full`}
              isSubmitting={isLoading}
              onClick={createPostHandler}
            >
              {defaultPostData.postMessage || defaultPostData.attachments
                ? "Update"
                : "Post"}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal
      isOpen={true}
      exitAnimation={!globalModalOpen}
      onClose={() => {}}
      customClass="!p-0 "
      isShowHeader={false}
    >
      {isShowFileUploadPopup ? (
        <div className="relative bg-white rounded-lg flex flex-col justify-between">
          <div className="text-center mx-auto flex flex-col justify-center items-center my-20 p-6 relative">
            <input
              type="file"
              className="opacity-0 absolute top-10 left-0 w-full h-full z-10"
              onChange={handleFileChange}
              accept={
                selectedFileType === "image"
                  ? "image/*"
                  : selectedFileType === "audio"
                    ? "audio/*"
                    : selectedFileType === "video"
                      ? "video/*"
                      : "application/*"
              }
              multiple
            />
            <div className="flex flex-col items-center">
              <div className="text-center mb-5 h-20 w-20 rounded-full bg-primary-600 flex justify-center items-center cursor-pointer">
                <FolderPlus />
              </div>
              <p className="text-xl font-semibold">Select files to begin</p>
              <p className="text-gray-500 mt-2">or drag and drop</p>
            </div>
            <Button customClasses="mt-4 text-white px-4 py-2">
              Upload from computer
            </Button>
          </div>
          <div className="w-full flex justify-end p-3 border-t border-primary-600">
            <Button
              variant="secondary"
              customClasses="mt-2"
              onClick={() => {
                setIsShowFileUploadPopup(false);
              }}
            >
              Close
            </Button>
          </div>
        </div>
      ) : (
        renderMainContent()
      )}
    </Modal>
  );
};

export default CreateFeed;
